import listActions from './listActions';

const calendarActions = {};

calendarActions.getCalendarStart = () => ({type: listActions.GET_CALENDAR_START});

calendarActions.getCalendarSuccess = (calendar) => ({
  type: listActions.GET_CALENDAR_SUCCESS,
  calendar,
});

calendarActions.getCalendarFail = () => ({type: listActions.GET_CALENDAR_FAIL});

export default calendarActions;



// WEBPACK FOOTER //
// ./src/store/actions/calendarActions.js